import React from 'react'
import { FormButton } from '@myxplor/forms'
import Icon from './icon'

const GovActionCancel = ({ toggle, icon, children }) => (
  <FormButton className="govListActions--cancel" onClick={toggle}>
    <Icon open icon={icon} /> {children}
  </FormButton>
)

export default GovActionCancel



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/toggle-cancel.jsx